import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    StepperPanelDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "flex-start",
        minWidth: 0
    }
});

export const useStyles = ({
    isSkipped,
    measures,
    isEmpty,
    colors,
    isDone,
    isLast,
    spaces
}: StepperPanelDynamicStyleType) => {
    const gutter = (measures.rowHeight - measures.markerSize) / 2 - spaces.spacingXxs;

    const styles = {
        container: {
            minHeight: measures.rowHeight - measures.markerSize - spaces.spacingXxs * 2 + spaces.spacingMd,
            paddingStart: measures.markerSize / 2 + measures.controlPadding - measures.line / 2,
            marginVertical: (measures.markerSize - measures.rowHeight) / 2 + spaces.spacingXxs,
            marginStart: measures.inset + measures.markerSize / 2 - measures.line / 2,
            borderStartColor: colors.content.border.subtle,
            paddingBottom: gutter + spaces.spacingMd,
            paddingTop: gutter + spaces.spacingXs,
            borderStartWidth: measures.line,
            gap: spaces.spacingMd
        } as Mutable<ViewStyle>
    };

    if(isEmpty) {
        delete styles.container.paddingBottom;

        delete styles.container.paddingTop;
    }

    if(isDone) {
        styles.container.borderStartColor = colors.content.container.primary;
    }

    if(isSkipped) {
        styles.container.borderStartColor = colors.content.border.default;

        styles.container.borderStyle = "dashed";
    }

    if(isLast) {
        styles.container.borderStartColor = "transparent";
    }

    return styles;
};
export default stylesheet;
